import { SyntacticSugarService } from '../../../../services/sys/syntactic-sugar.service';
import { Directive, HostListener, Input, Output } from '@angular/core'
import { EventEmitter, ElementRef } from '@angular/core'

declare var jQuery: any;

@Directive ({
    selector: '[gdEmitBothValuesOnChange]',
    standalone: false
})

/**
 * Use this directive if you want to compare changed field values to the field value
 * present when the view was loaded. The event emitted will contain two values; the first
 * is the value in the field when the view was loaded, the second is the current value.
 */
export class GdEmitBothValuesOnChangeDirective {
    
    @Output() gdBothValuesChange: EventEmitter<[string, string]> = new EventEmitter<[string, string]>();
    
    priorValue: string;
    
    constructor(private element : ElementRef,
        private syntacticSugarService: SyntacticSugarService) {}
    
    /**
     * Listen for the focus to be place on the field and initialize the priorValue.
     * This doesn't happen in an angular-provided hook because the value isn't yet in the
     * DOM element for us to get.
     */
    @HostListener('gdFocus')
    onFocus() : void {
        if(this.syntacticSugarService.isObjectUndefined(this.priorValue)) {
            let fieldName = jQuery(this.element.nativeElement).attr("gdFieldId");
            this.priorValue = jQuery("#" + fieldName).val()
        }
    }
    
    @HostListener('gdModelChange', ['$event']) 
    onModelChange(event: string) { 
        setTimeout(() => {
            this.gdBothValuesChange.next([this.priorValue, event]);
        },0);
    }

}